import { HeaderClassic } from './HeaderClassic';
import { HeaderWithBackButton } from './HeaderWithBackButton';
import { HeaderWithExitButton } from './HeaderWithExitButton';
import { HeaderWithoutExitButton } from './HeaderWithoutExitButton';
import { HeaderWithSearch } from './HeaderWithSearch';
import { HeaderWithTabs } from './HeaderWithTabs';

export const Header = {
  Classic: HeaderClassic,
  WithBackButton: HeaderWithBackButton,
  WithExitButton: HeaderWithExitButton,
  WithoutExitButton: HeaderWithoutExitButton,
  WithSearch: HeaderWithSearch,
  WithTabs: HeaderWithTabs,
};
